"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgMenuHamb = function (props) {
    var color = props.color;
    return (react_1.default.createElement("path", { fill: color, fillRule: "evenodd", d: "M19 17C19.5523 17 20 17.4477 20 18C20 18.5128 19.614 18.9355 19.1166 18.9933L19 19H5C4.44772 19 4 18.5523 4 18C4 17.4872 4.38604 17.0645 4.88338 17.0067L5 17H19ZM19 11C19.5523 11 20 11.4477 20 12C20 12.5128 19.614 12.9355 19.1166 12.9933L19 13H5C4.44772 13 4 12.5523 4 12C4 11.4872 4.38604 11.0645 4.88338 11.0067L5 11H19ZM19 5C19.5523 5 20 5.44772 20 6C20 6.51284 19.614 6.93551 19.1166 6.99327L19 7H5C4.44772 7 4 6.55228 4 6C4 5.48716 4.38604 5.06449 4.88338 5.00673L5 5H19Z" }));
};
exports.default = factorySvgIcon_1.default(SvgMenuHamb);
//# sourceMappingURL=SvgMenuHamb.js.map